import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { ApiResponse } from '../models/api-response.models';
import { DashboardSummary } from '../models/user.models';
import { unwrapApiResponse } from '../utils/api-response';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private readonly api = inject(ApiService);

  summary(): Observable<DashboardSummary> {
    return this.api
      .get<ApiResponse<DashboardSummary> | DashboardSummary>(API_ENDPOINTS.dashboard)
      .pipe(map((response) => unwrapApiResponse(response)));
  }

  businessSales(): Observable<BusinessSalesSummary> {
    return this.api
      .get<ApiResponse<BusinessSalesSummary> | BusinessSalesSummary>('/orders/dashboard/business-sales', undefined, 'marketplace')
      .pipe(map((response) => unwrapApiResponse(response)));
  }
}

export interface BusinessSalesSummary {
  period: string;
  onlineSales: number;
  onlineRevenue: number;
  storeSales: number;
  storeRevenue: number;
  totalOrders: number;
  unitsSold: number;
  totalRevenue: number;
  costOfGoods: number;
  grossProfit: number;
  inventoryUnits: number;
  inventoryValue: number;
  readyToSellUnits: number;
  recentSales: Array<{
    id: string;
    saleChannel: 'Online' | 'Store' | string;
    totalAmount: number;
    quantity: number;
    productTitle: string;
    status: string | number;
    createdAt: string;
  }>;
}
